import posthog from "posthog-js";

export const FEATURE_GROUPS = {
  NAVIGATION: "Navigation & Pages",
  CORE: "Core Features",
  EXPERIMENTAL: "Experimental",
  INTEGRATIONS: "Integrations",
} as const;

export const FEATURE_TOGGLES = {
  // Navigation/Page toggles
  DASHBOARD: {
    key: "dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Main dashboard page access",
  },
  MY_PRODUCTS: {
    key: "my-products-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Products page and functionality",
  },
  CRO_MODULE: {
    key: "cro-module-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Conversion Rate Optimization module",
  },
  AD_CAMPAIGN_MANAGER: {
    key: "ad-campaign-manager-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Ad Campaign Manager access",
  },
  FINANCE: {
    key: "finance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Finance module and reports",
  },
  SUPPLY_CHAIN: {
    key: "supply-chain-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Supply chain management tools",
  },
  MARKET_INTELLIGENCE: {
    key: "market-intelligence-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market intelligence and insights",
  },
  WORKFLOWS: {
    key: "workflows-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: false,
    description: "Workflow automation tools",
  },
  CANVAS: {
    key: "canvas-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canvas visual editor",
  },
  CUSTOMER_JOURNEY_MAP: {
    key: "customer-journey-map-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: false,
    description: "Customer Journey Map visualization",
  },
  CUSTOMERS: {
    key: "customers-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: false,
    description: "Customer management (staff only)",
  },
  //blocks
  HEADER_DASHBOARD: {
    key: "blocks--header-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Header dashboard automation tools",
  },
  TITLE_CALENDAR_DASHBOARD: {
    key: "blocks--title-calendar-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Header - calendar dashboard and insights",
  },
  EXECUTIVE_SUMMARY_DASHBOARD: {
    key: "blocks--executive-summary-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Executive Summary dashboard and insights",
  },
  SALES_PERFORMANCE_DASHBOARD: {
    key: "blocks--sales_perfomance-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Sales Performance dashboard and insights",
  },
  SUBSCRIPTION_PERFORMANCE: {
    key: "blocks--subscription-performance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Subscription Performance analytics",
  },
  PRODUCT_SECTION_DASHBOARD: {
    key: "blocks--product-section-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Product Section dashboard and insights",
  },
  SPIDER_COMPONENT_DASHBOARD: {
    key: "blocks--spider-component-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Spider Component dashboard",
  },
  PROBLEMS_COMPONENT_DASHBOARD: {
    key: "blocks--problems-component-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Problems Component dashboard",
  },
  SOLUTIONS_COMPONENT_DASHBOARD: {
    key: "blocks--sulutions-component-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Solutions Component dashboard",
  },
  ASPECT_IMPROVE_COMPONENT_DASHBOARD: {
    key: "blocks--aspect-improve-component-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Steps to improve review score Component dashboard",
  },
  ASPECT_INSIGHTS_COMPONENT_DASHBOARD: {
    key: "blocks--aspect-insights-component-dashboard-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Aspect Insight Component dashboard",
  },
  //blocks My Products
  MY_PRODUCTS_HEADER: {
    key: "blocks--my-products-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section and insights",
  },
  MY_PRODUCTS_INPUT_COMPARE: {
    key: "blocks--my-products-input-compare-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section and insights",
  },
  MY_PRODUCTS_BLOCK: {
    key: "blocks--my-products-view-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section and insights",
  },
  MY_PRODUCTS_ASPECTS: {
    key: "blocks--my-products-aspects-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section Aspects and insights",
  },
  MY_PRODUCTS_SCORE: {
    key: "blocks--my-products-score-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section Score and insights",
  },
  MY_PRODUCTS_REVIEW_LIST: {
    key: "blocks--my-products-review-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "My Product Section Reviews and insights",
  },
  //blocks CRO
  CRO_HEADER: {
    key: "blocks--cro-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CRO Section and insights",
  },
  CRO_INPUT: {
    key: "blocks--cro-input-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CRO Input Section and insights",
  },
  CRO_LEFT: {
    key: "blocks--cro-left-section-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CRO Left Section and insights",
  },
  CRO_CENTER: {
    key: "blocks--cro-center-section-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CRO Center Section and insights",
  },
  CRO_RIGHT: {
    key: "blocks--cro-right-section-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CRO Right Section and insights",
  },

  //blocks Ad Campaign Manager
  AD_CAMPAIGN_MANAGER_HEADER: {
    key: "blocks-ad-campaign-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Ad Campaign Manager Header Section and insights",
  },
  AD_CAMPAIGN_MANAGER_EXECUTIVE_SUMMARY: {
    key: "blocks-ad-campaign-executive-summary-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Ad Campaign Manager Executive Summary Section and insights",
  },
  AD_CAMPAIGN_MANAGER_SALES_PERFORMANCE: {
    key: "blocks-ad-campaign-sales-perfomance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Ad Campaign Manager Sales Performance Section and insights",
  },
  AD_CAMPAIGN_MANAGER_CAMPAIGN_TABLE: {
    key: "blocks-ad-campaign-campaign-table-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Ad Campaign Manager Campaign Table Section and insights",
  },

  //blocks CFO
  CFO_HEADER: {
    key: "blocks-cfo-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Header Section and insights",
  },
  CFO_EXECUTIVE_SUMMARY: {
    key: "blocks-cfo-executive-summary-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Executive Summary Section and insights",
  },
  CFO_TOTAL_BLOCK: {
    key: "blocks-cfo-total-sales-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Total Sales Section and insights",
  },
  CFO_CONTRIBUTION_BLOCK: {
    key: "blocks-cfo-contribution-profit-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Contribution Profit Section and insights",
  },
  CFO_FINANCIAL_OVERVIEW_BLOCK: {
    key: "blocks-cfo-financial-overview-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Financial Overview Section and insights",
  },
  CFO_CASH_FLOW_BLOCK: {
    key: "blocks-cfo-cash-flow-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Cash Flow Section and insights",
  },
  CFO_PRODUCT_COST_TABLE: {
    key: "blocks-cfo-product-cost-table-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Product Cost Section and insights",
  },
  CFO_WATERFALL_CHART: {
    key: "blocks-cfo-waterfall-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Waterfall Chart and insights",
  },
  CFO_SUPPLY_CHAIN_BLOCK: {
    key: "blocks-cfo-supply-chain-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "CFO Supply Chain Section and insights",
  },
  COO_HEADER: {
    key: "blocks-coo-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Header Section and insights",
  },
  COO_EXECUTIVE_SUMMARY: {
    key: "blocks-coo-executive-summary-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Executive Summary Section and insights",
  },
  COO_INVENTORY_PERFORMANCE: {
    key: "blocks-coo-inventory-perfomance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Inventory Performance Section and insights",
  },
  COO_FLOW_PROGRESS_LINE: {
    key: "blocks-coo-flow-progress-line-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Flow Progress Line Section and insights",
  },
  COO_SUPPLY_CHAIN_BLOCK: {
    key: "blocks-coo-supply-chain-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Supply Chain Section and insights",
  },
  COO_SCHEDULER: {
    key: "blocks-coo-scheduler-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Scheduler Section and insights",
  },
  COO_INVENTORY_OVERVIEW: {
    key: "blocks-coo-inventory-overview-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Inventory Overview Section and insights",
  },
  COO_MANAGE_DATA_ENTRIES: {
    key: "blocks-coo-manage-data-entries-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "COO Manage Data Entries Section and insights",
  },

  MARKET_HEADER: {
    key: "blocks-market-intelligence-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Header Section and insights",
  },
  MARKET_EXECUTIVE_SUMMARY: {
    key: "blocks-market-executive-summary-header-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Executive Summary Section and insights",
  },
  MARKET_MARKET_LEVEL_CHART: {
    key: "blocks-market-level-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Level Chart Section and insights",
  },
  MARKET_MARKET_OVERVIEW_CHART: {
    key: "blocks-market-overview-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Overview Chart Section and insights",
  },
  MARKET_MARKET_SHARE_CHART: {
    key: "blocks-market-share-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Share Chart Section and insights",
  },
  MARKET_MARKET_SALES_CHART: {
    key: "blocks-market-sales-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Sales Chart Section and insights",
  },
  MARKET_BRAND_TABLE: {
    key: "blocks-market-brand-table-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Brand Table Section and insights",
  },
  MARKET_BRAND_PERFORMANCE_CHART: {
    key: "blocks-market-brand-perfomance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description:
      "Market Intelligence Brand Performance Chart Section and insights",
  },
  MARKET_TOTAL_SALES_CHART: {
    key: "blocks-market-total-sales-chart-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Total Sales Chart Section and insights",
  },
  MARKET_PRODUCTS_BLOCK: {
    key: "blocks-market-products-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Market Intelligence Products Block Section and insights",
  },
  //blocks CANVA
  CANVA_SUMMARY: {
    key: "blocks-canva-summary-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Summary Section and insights",
  },
  CANVA_REVENUE: {
    key: "blocks-canva-revenue-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Revenue Section and insights",
  },
  CANVA_FINANCE: {
    key: "blocks-canva-finance-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Finance Section and insights",
  },
  CANVA_SUPPLY_CHAIN: {
    key: "blocks-canva-supply-chain-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Supply Chain Section and insights",
  },
  CANVA_MARKET_INTELLIGENCE: {
    key: "blocks-canva-market-intelligence-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Market Intelligence Section and insights",
  },
  CANVA_CUSTOM_REPORTS: {
    key: "blocks-canva-custom-reports-enabled",
    group: FEATURE_GROUPS.NAVIGATION,
    default: true,
    description: "Canva Custom Reports Section and insights",
  },
  // Core Features
  REVENUE_ANALYTICS: {
    key: "revenue-analytics-enabled",
    group: FEATURE_GROUPS.CORE,
    default: true,
    description: "Revenue analytics and reporting",
  },
  TASK_MANAGER: {
    key: "task-manager-enabled",
    group: FEATURE_GROUPS.CORE,
    default: false,
    description: "Task management system",
  },
  CHAT_BOT: {
    key: "chat-bot-enabled",
    group: FEATURE_GROUPS.CORE,
    default: false,
    description: "AI chat bot functionality",
  },
  CHAT_STRATEGY_SELECTOR: {
    key: "chat-strategy-selector-enabled",
    group: FEATURE_GROUPS.EXPERIMENTAL,
    default: false,
    description: "Chat strategy selector dropdown for debugging",
  },
  HELP_CENTER: {
    key: "help-center-enabled",
    group: FEATURE_GROUPS.CORE,
    default: true,
    description: "Help center and documentation",
  },

  // Experimental Features
  PHOTO_OPTIMIZATION: {
    key: "photo-optimization-enabled",
    group: FEATURE_GROUPS.EXPERIMENTAL,
    default: true,
    description: "Photo optimization tools",
  },
  VIDEO_OPTIMIZATION: {
    key: "video-optimization-enabled",
    group: FEATURE_GROUPS.EXPERIMENTAL,
    default: false,
    description: "Video optimization features",
  },
  LISTING_OPTIMIZATION: {
    key: "listing-optimization-enabled",
    group: FEATURE_GROUPS.EXPERIMENTAL,
    default: true,
    description: "Product listing optimization",
  },
  ADS_ANALYTICS: {
    key: "ads-analytics-enabled",
    group: FEATURE_GROUPS.EXPERIMENTAL,
    default: true,
    description: "Advanced ads analytics",
  },

  // Platform Integrations
  AMAZON_CONNECT: {
    key: "amazon-connect-enabled",
    group: FEATURE_GROUPS.INTEGRATIONS,
    default: true,
    description: "Amazon Connect integration",
  },
  SELLER_CENTRAL: {
    key: "seller-central-enabled",
    group: FEATURE_GROUPS.INTEGRATIONS,
    default: true,
    description: "Seller Central integration",
  },
} as const;

export type FeatureToggleKey = keyof typeof FEATURE_TOGGLES;

// Event emitter for internal communication
class EventEmitter {
  private readonly listeners: Map<string, Set<(...args: any[]) => void>> =
    new Map();

  addListener(event: string, callback: (...args: any[]) => void): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  removeListener(event: string, callback: (...args: any[]) => void): void {
    this.listeners.get(event)?.delete(callback);
  }

  emit(event: string, ...args: any[]): void {
    this.listeners.get(event)?.forEach((listener) => listener(...args));
  }

  dispose(): void {
    this.listeners.clear();
  }
}

// Feature toggle state management
export class FeatureToggleManager {
  private static instance: FeatureToggleManager | null = null;
  private readonly cache: Map<string, boolean> = new Map();
  private isInitialized = false;
  private userId: string | null = null;
  private readonly eventEmitter = new EventEmitter();
  private posthogUnsubscribe: (() => void) | null = null;

  private constructor() {}

  static getInstance(): FeatureToggleManager {
    if (!FeatureToggleManager.instance) {
      FeatureToggleManager.instance = new FeatureToggleManager();
    }
    return FeatureToggleManager.instance;
  }

  /**
   * Initialize feature toggles with PostHog (user-aware)
   */
  async initialize(userId?: string): Promise<void> {
    if (this.isInitialized && this.userId === userId) return;
    this.userId = userId ?? null;
    try {
      if (userId) posthog.identify(userId);
      await this.syncFromPosthog();
      this.subscribeToPosthogUpdates();
      this.isInitialized = true;
    } catch (error) {
      console.warn("Failed to initialize PostHog feature toggles:", error);
      this.initializeWithDefaults();
    }
  }

  /**
   * Sync all flags from PostHog using individual flag calls (PostHog doesn't support bulk fetch)
   */
  private async syncFromPosthog(): Promise<void> {
    try {
      const flagPromises = Object.values(FEATURE_TOGGLES).map(async (meta) => {
        const raw = posthog.getFeatureFlag(meta.key);
        return [meta.key, raw ?? meta.default] as [string, any];
      });
      const flagResults = await Promise.all(flagPromises);
      // Update cache with PostHog values, falling back to defaults
      flagResults.forEach(([key, value]) => {
        this.cache.set(key, Boolean(value));
      });
      // Notify all listeners that flags have updated (event-driven)
      this.eventEmitter.emit("flagsUpdated");
    } catch (error) {
      console.warn("[FeatureToggles] Failed to sync from PostHog:", error);
      this.initializeWithDefaults();
    }
  }

  /**
   * Subscribe to real-time PostHog updates (replaces polling + waitForPostHog)
   */
  private subscribeToPosthogUpdates(): void {
    if (
      posthog.onFeatureFlags &&
      typeof posthog.onFeatureFlags === "function"
    ) {
      this.posthogUnsubscribe = posthog.onFeatureFlags(() => {
        void this.syncFromPosthog();
      });
    }
  }

  /**
   * Initialize with default states when PostHog is unavailable
   */
  private initializeWithDefaults(): void {
    Object.values(FEATURE_TOGGLES).forEach((meta) => {
      this.cache.set(meta.key, meta.default);
    });
    this.isInitialized = true;
    this.eventEmitter.emit("flagsUpdated");
  }

  /**
   * Get feature toggle state
   */
  isFeatureEnabled(featureKey: FeatureToggleKey): boolean {
    const meta = FEATURE_TOGGLES[featureKey];
    if (!meta) {
      console.warn(`[FeatureToggles] Unknown feature key: ${featureKey}`);
      return false;
    }
    return this.cache.get(meta.key) ?? meta.default;
  }

  /**
   * Get all feature states (for debug panel)
   */
  getAllFeatureStates(): Record<string, boolean> {
    const states: Record<string, boolean> = {};
    Object.values(FEATURE_TOGGLES).forEach((meta) => {
      states[meta.key] = this.cache.get(meta.key) ?? meta.default;
    });
    return states;
  }

  /**
   * Override feature toggle state (for debug panel)
   */
  overrideFeature(featureKey: FeatureToggleKey, enabled: boolean): void {
    const meta = FEATURE_TOGGLES[featureKey];
    this.cache.set(meta.key, enabled);

    // Store in localStorage for persistence
    const overrides = this.getStoredOverrides();
    overrides[meta.key] = enabled;
    localStorage.setItem("ft_debug_overrides", JSON.stringify(overrides));
    this.eventEmitter.emit("flagsUpdated");
  }

  /**
   * Get stored debug overrides
   */
  private getStoredOverrides(): Record<string, boolean> {
    try {
      const stored = localStorage.getItem("ft_debug_overrides");
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  }

  /**
   * Load debug overrides from localStorage
   */
  loadDebugOverrides(): void {
    const overrides = this.getStoredOverrides();
    Object.entries(overrides).forEach(([k, v]) => this.cache.set(k, v));
    this.eventEmitter.emit("flagsUpdated");
  }

  /**
   * Clear debug overrides
   */
  clearDebugOverrides(): void {
    localStorage.removeItem("ft_debug_overrides");
    this.syncFromPosthog();
  }

  /**
   * Add listener for flag updates (event-driven)
   */
  addListener(callback: () => void): () => void {
    this.eventEmitter.addListener("flagsUpdated", callback);
    return () => this.eventEmitter.removeListener("flagsUpdated", callback);
  }

  /**
   * Dispose of the manager (for testing)
   */
  dispose(): void {
    if (this.posthogUnsubscribe) this.posthogUnsubscribe();
    this.eventEmitter.dispose();
    this.cache.clear();
    this.isInitialized = false;
    this.userId = null;
  }

  /**
   * Get initialization status (proper getter to avoid private property access)
   */
  get initialized(): boolean {
    return this.isInitialized;
  }

  /**
   * Force initialization with default values (for timeout scenarios)
   */
  forceInitializeWithDefaults(): void {
    if (!this.isInitialized) this.initializeWithDefaults();
  }

  /**
   * Debug: Get raw PostHog flags for debugging
   */
  debugGetPostHogFlags(): Record<string, any> {
    const flags: Record<string, any> = {};
    Object.values(FEATURE_TOGGLES).forEach((meta) => {
      try {
        const rawValue = posthog.getFeatureFlag(meta.key);
        flags[meta.key] = {
          rawValue,
          boolean: Boolean(rawValue),
          default: meta.default,
        };
      } catch (e) {
        flags[meta.key] = { error: (e as Error).message };
      }
    });
    return flags;
  }

  /**
   * Debug: Force sync from PostHog (for manual testing)
   */
  debugForceSync(): Promise<void> {
    return this.syncFromPosthog();
  }

  /**
   * Debug: Get all current cache state
   */
  debugGetCacheState(): Record<string, boolean> {
    return Object.fromEntries(this.cache);
  }
  /**
   * Debug: Compare PostHog vs Cache values
   */
  debugCompareValues(): Record<
    string,
    { posthog: any; cache: boolean; match: boolean }
  > {
    const comparison: Record<string, any> = {};
    Object.values(FEATURE_TOGGLES).forEach((meta) => {
      try {
        const ph = posthog.getFeatureFlag(meta.key);
        const c = this.cache.get(meta.key) ?? meta.default;
        comparison[meta.key] = {
          posthog: ph,
          cache: c,
          match: Boolean(ph) === c,
        };
      } catch (e) {
        comparison[meta.key] = {
          posthog: (e as Error).message,
          cache: this.cache.get(meta.key) ?? meta.default,
          match: false,
        };
      }
    });
    return comparison;
  }
}

export const featureToggleManager = FeatureToggleManager.getInstance();

if (typeof window !== "undefined") {
  (window as any).debugFeatureToggles = {
    getPostHogFlags: () => featureToggleManager.debugGetPostHogFlags(),
    forceSync: () => featureToggleManager.debugForceSync(),
    getCacheState: () => featureToggleManager.debugGetCacheState(),
    compareValues: () => featureToggleManager.debugCompareValues(),
    summary: () => {
      console.log("=== FEATURE TOGGLES DEBUG SUMMARY ===");
      console.log(
        "PostHog Flags:",
        featureToggleManager.debugGetPostHogFlags(),
      );
      console.log("Cache State:", featureToggleManager.debugGetCacheState());
      console.log("Comparison:", featureToggleManager.debugCompareValues());
      console.log("Initialized:", featureToggleManager.initialized);
    },
  };
  console.log(
    "🐛 Debug feature toggles with: window.debugFeatureToggles.summary()",
  );
}
/**
 * Factory for creating mock feature managers (for testing)
 */
export function createMockFeatureManager(
  overrides: Record<string, boolean> = {},
): FeatureToggleManager {
  const mock = new (FeatureToggleManager as any)();
  Object.values(FEATURE_TOGGLES).forEach((meta) => {
    mock.cache.set(meta.key, overrides[meta.key] ?? meta.default);
  });
  mock.isInitialized = true;
  return mock;
}
